import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { SECURITY_CONTAINER } from '@/constants';

const AuthDropdownContext = createContext();

function AuthDropdownProvider (props) {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState(SECURITY_CONTAINER.login);
  const { pathname } = useLocation();
  
  useEffect(() => {
    if (pathname.match(SECURITY_CONTAINER.signup)) {
      setIsOpen(true);
      setView(null);
    }
  }, [pathname]);
  
  return (
    <AuthDropdownContext.Provider value={{
      isOpen,
      view,
      setIsOpen,
      setView
    }} {...props} />
  );
}

function useAuthDropdown () {
  const context = useContext(AuthDropdownContext);
  if (context === undefined) {
    throw new Error('useAuthDropdown must be used within a AuthDropdownProvider');
  }
  const {
    isOpen,
    view,
    setIsOpen,
    setView
  } = context;
  
  return {
    isOpen,
    view,
    setIsOpen,
    setView
  };
}

AuthDropdownProvider.propTypes = {};

export { AuthDropdownProvider, useAuthDropdown };
